"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.L2ERC20Gateway__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "DepositFinalized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "_id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "TxToL1",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "l1Token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "_l2ToL1Id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_exitNum",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "WithdrawalInitiated",
        type: "event",
    },
    {
        inputs: [],
        name: "beaconProxyFactory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1ERC20",
                type: "address",
            },
        ],
        name: "calculateL2TokenAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "cloneableProxyHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "counterpartGateway",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "exitNum",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "finalizeInboundTransfer",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "getOutboundCalldata",
        outputs: [
            {
                internalType: "bytes",
                name: "outboundCalldata",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "l1ERC20",
                type: "address",
            },
        ],
        name: "getUserSalt",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_l1Counterpart",
                type: "address",
            },
            {
                internalType: "address",
                name: "_router",
                type: "address",
            },
            {
                internalType: "address",
                name: "_beaconProxyFactory",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_l1Token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "outboundTransfer",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_l1Token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "outboundTransfer",
        outputs: [
            {
                internalType: "bytes",
                name: "res",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "postUpgradeInit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "router",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506114b9806100206000396000f3fe6080604052600436106100b25760003560e01c806397881f8d1161006f57806397881f8d14610182578063a0c76a9614610197578063a7e28d48146101b7578063c05e6a95146101d7578063c0c53b8b146101f7578063d2ce7d6514610217578063f887ea401461022a57600080fd5b8063015234ab146100b75780632db09c1c146100e05780632e567b3614610118578063569f26ff1461012d5780637b3a3c8b1461014d57806395fcea781461016d575b600080fd5b3480156100c357600080fd5b506100cd60025481565b6040519081526020015b60405180910390f35b3480156100ec57600080fd5b50600054610100906001600160a01b031681565b6040516001600160a01b0390911681526020016100d7565b61012b610126366004610f3e565b61024a565b005b34801561013957600080fd5b506100cd610148366004610fc2565b6104a5565b61016061015b366004610fe6565b6104d9565b6040516100d791906110a8565b34801561017957600080fd5b5061012b6104f5565b34801561018e57600080fd5b506100cd61056d565b3480156101a357600080fd5b506101606101b236600461115d565b6105e0565b3480156101c357600080fd5b506101006101d2366004610fc2565b61064b565b3480156101e357600080fd5b50600354610100906001600160a01b031681565b34801561020357600080fd5b5061012b6102123660046111db565b6106cd565b610160610225366004611226565b610742565b34801561023657600080fd5b50600154610100906001600160a01b031681565b600054610268906001600160a01b031661111161111160901b010190565b6001600160a01b0316336001600160a01b0316146102c85760405162461bcd60e51b81526020600482015260186024820152774f4e4c595f434f554e544552504152545f4741544557415960401b60448201526064015b60405180910390fd5b6000806102d5848461098e565b9150915080516000146102f357506040805160208101909152600081525b60006102fe8961064b565b90506001600160a01b0381163b61033257600061031f8a838b8b8b896109a8565b90508015610330575050505061049d565b505b60408051600481526024810182526020810180516001600160e01b031663c2eeeebd60e01b179052905160009182916001600160a01b03851691610375916112ab565b600060405180830381855afa9150503d80600081146103b0576040519150601f19603f3d011682016040523d82523d6000602084013e6103b5565b606091505b509150915060008215806103ca575060208251105b156103d757506001610406565b60006103e483600c610adc565b90508c6001600160a01b0316816001600160a01b03161461040457600191505b505b8015610434576104288c308d8c60405180602001604052806000815250610b3e565b5050505050505061049d565b505050610442818888610bbe565b866001600160a01b0316886001600160a01b03168a6001600160a01b03167fc7f2e9c55c40a50fbc217dfc70cd39a222940dfa62145aa0ca49eb9535d4fcb28960405161049191815260200190565b60405180910390a45050505b505050505050565b604080516001600160a01b038316602082015260009101604051602081830303815290604052805190602001209050919050565b60606104eb8686866000808888610742565b9695505050505050565b600061051f7fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035490565b9050336001600160a01b0382161461056a5760405162461bcd60e51b815260206004820152600e60248201526d2727aa2fa32927a6afa0a226a4a760911b60448201526064016102bf565b50565b600354604080516397881f8d60e01b815290516000926001600160a01b0316916397881f8d9160048083019260209291908290030181865afa1580156105b7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105db91906112c7565b905090565b6060632e567b3660e01b868686866105fa60025488610c23565b60405160240161060e9594939291906112e0565b60408051601f198184030181529190526020810180516001600160e01b03166001600160e01b031990931692909217909152905095945050505050565b6003546000906001600160a01b031663e75b214130610669856104a5565b6040518363ffffffff1660e01b8152600401610686929190611326565b602060405180830381865afa1580156106a3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106c7919061133f565b92915050565b6106d78383610c4f565b6001600160a01b03811661071e5760405162461bcd60e51b815260206004820152600e60248201526d24a72b20a624a22fa122a0a1a7a760911b60448201526064016102bf565b600380546001600160a01b0319166001600160a01b03929092169190911790555050565b6060341561077d5760405162461bcd60e51b81526020600482015260086024820152674e4f5f56414c554560c01b60448201526064016102bf565b6001546000906060906001600160a01b031633036107a95761079f8585610ca0565b90925090506107e6565b33915084848080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920191909152509293505050505b80511561082b5760405162461bcd60e51b8152602060048201526013602482015272115615149057d110551057d11254d050931151606a1b60448201526064016102bf565b6000806108378c61064b565b90506001600160a01b0381163b6108855760405162461bcd60e51b81526020600482015260126024820152711513d2d15397d393d517d111541313d6515160721b60448201526064016102bf565b8b6001600160a01b0316816001600160a01b031663c2eeeebd6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156108cd573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906108f1919061133f565b6001600160a01b03161461093f5760405162461bcd60e51b81526020600482015260156024820152742727aa2fa2ac2822a1aa22a22fa618afaa27a5a2a760591b60448201526064016102bf565b61094a81858c610cbc565b99506109598c858d8d87610b3e565b9150508060405160200161096f91815260200190565b6040516020818303038152906040529350505050979650505050505050565b60608061099d8385018561135c565b909590945092505050565b6000806109b4886104a5565b6003546040516329a5c5cf60e01b8152600481018390529192506000916001600160a01b03909116906329a5c5cf906024016020604051808303816000875af1158015610a05573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a29919061133f565b604051630c4edbe960e11b81529091506001600160a01b0382169063189db7d290610a5a908c9088906004016113bf565b600060405180830381600087803b158015610a7457600080fd5b505af1158015610a88573d6000803e3d6000fd5b50505050876001600160a01b0316816001600160a01b031603610ab0576000925050506104eb565b610acc8930898860405180602001604052806000815250610b3e565b5060019998505050505050505050565b6000610ae98260146113f9565b83511015610b2e5760405162461bcd60e51b815260206004820152601260248201527152656164206f7574206f6620626f756e647360701b60448201526064016102bf565b500160200151600160601b900490565b60025460009081610b5c8786610b578b838b848b6105e0565b610d27565b604080516001600160a01b038b81168252602082018690529181018890529192508291818916918a16907f3073a74ecb728d10be779fe19a74a1428e20468f5b4d167bf9c73d9067847d739060600160405180910390a4979650505050505050565b6040516346154c9f60e11b81526001600160a01b03841690638c2a993e90610bec9085908590600401611326565b600060405180830381600087803b158015610c0657600080fd5b505af1158015610c1a573d6000803e3d6000fd5b50505050505050565b60608282604051602001610c3892919061140c565b604051602081830303815290604052905092915050565b610c598282610d5f565b6001600160a01b038116610c9c5760405162461bcd60e51b815260206004820152600a6024820152692120a22fa927aaaa22a960b11b60448201526064016102bf565b5050565b60006060610cb083850185611425565b915091505b9250929050565b6040516374f4f54760e01b81526000906001600160a01b038516906374f4f54790610ced9086908690600401611326565b600060405180830381600087803b158015610d0757600080fd5b505af1158015610d1b573d6000803e3d6000fd5b50939695505050505050565b6002805460009182610d388361146a565b909155505060008054610d57919086906001600160a01b031685610e21565b949350505050565b6001600160a01b038216610dab5760405162461bcd60e51b81526020600482015260136024820152721253959053125117d0d3d55395115494105495606a1b60448201526064016102bf565b6000546001600160a01b031615610df35760405162461bcd60e51b815260206004820152600c60248201526b1053149150511657d253925560a21b60448201526064016102bf565b600080546001600160a01b039384166001600160a01b03199182161790915560018054929093169116179055565b6040516349460b4d60e11b8152600090819060649063928c169a908890610e4e90889088906004016113bf565b60206040518083038185885af1158015610e6c573d6000803e3d6000fd5b50505050506040513d601f19601f82011682018060405250810190610e9191906112c7565b905080846001600160a01b0316866001600160a01b03167f2b986d32a0536b7e19baa48ab949fec7b903b7fad7730820b20632d100cc3a6886604051610ed791906110a8565b60405180910390a495945050505050565b6001600160a01b038116811461056a57600080fd5b60008083601f840112610f0f57600080fd5b5081356001600160401b03811115610f2657600080fd5b602083019150836020828501011115610cb557600080fd5b60008060008060008060a08789031215610f5757600080fd5b8635610f6281610ee8565b95506020870135610f7281610ee8565b94506040870135610f8281610ee8565b93506060870135925060808701356001600160401b03811115610fa457600080fd5b610fb089828a01610efd565b979a9699509497509295939492505050565b600060208284031215610fd457600080fd5b8135610fdf81610ee8565b9392505050565b600080600080600060808688031215610ffe57600080fd5b853561100981610ee8565b9450602086013561101981610ee8565b93506040860135925060608601356001600160401b0381111561103b57600080fd5b61104788828901610efd565b969995985093965092949392505050565b60005b8381101561107357818101518382015260200161105b565b50506000910152565b60008151808452611094816020860160208601611058565b601f01601f19169290920160200192915050565b602081526000610fdf602083018461107c565b634e487b7160e01b600052604160045260246000fd5b600082601f8301126110e257600080fd5b81356001600160401b03808211156110fc576110fc6110bb565b604051601f8301601f19908116603f01168101908282118183101715611124576111246110bb565b8160405283815286602085880101111561113d57600080fd5b836020870160208301376000602085830101528094505050505092915050565b600080600080600060a0868803121561117557600080fd5b853561118081610ee8565b9450602086013561119081610ee8565b935060408601356111a081610ee8565b92506060860135915060808601356001600160401b038111156111c257600080fd5b6111ce888289016110d1565b9150509295509295909350565b6000806000606084860312156111f057600080fd5b83356111fb81610ee8565b9250602084013561120b81610ee8565b9150604084013561121b81610ee8565b809150509250925092565b600080600080600080600060c0888a03121561124157600080fd5b873561124c81610ee8565b9650602088013561125c81610ee8565b955060408801359450606088013593506080880135925060a08801356001600160401b0381111561128c57600080fd5b6112988a828b01610efd565b989b979a50959850939692959293505050565b600082516112bd818460208701611058565b9190910192915050565b6000602082840312156112d957600080fd5b5051919050565b6001600160a01b0386811682528581166020830152841660408201526060810183905260a06080820181905260009061131b9083018461107c565b979650505050505050565b6001600160a01b03929092168252602082015260400190565b60006020828403121561135157600080fd5b8151610fdf81610ee8565b6000806040838503121561136f57600080fd5b82356001600160401b038082111561138657600080fd5b611392868387016110d1565b935060208501359150808211156113a857600080fd5b506113b5858286016110d1565b9150509250929050565b6001600160a01b0383168152604060208201819052600090610d579083018461107c565b634e487b7160e01b600052601160045260246000fd5b808201808211156106c7576106c76113e3565b828152604060208201526000610d57604083018461107c565b6000806040838503121561143857600080fd5b823561144381610ee8565b915060208301356001600160401b0381111561145e57600080fd5b6113b5858286016110d1565b60006001820161147c5761147c6113e3565b506001019056fea2646970667358221220e1ea7c4eb3ca65922956efd20c48f87f8f415097417c7aa7cde5fcf29c8a653864736f6c63430008100033";
const isSuperArgs = (xs) => xs.length > 1;
class L2ERC20Gateway__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "L2ERC20Gateway";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.L2ERC20Gateway__factory = L2ERC20Gateway__factory;
L2ERC20Gateway__factory.bytecode = _bytecode;
L2ERC20Gateway__factory.abi = _abi;
